import { isValidElement } from 'react';
const TabGroup = function TabGroup() {
    return null;
};
TabGroup.displayName = 'TabGroup';
TabGroup.__IS_TAB_GROUP = true;
export function isTabGroup(el) {
    return isValidElement(el) && el.type.__IS_TAB_GROUP;
}
export default TabGroup;
